import * as React from "react"

const ArrowExpand = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={8}
    fill="none"
    {...props}
  >
    <path
      stroke="#14181F"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12.833 1 6.999 6.833 1.166 1"
    />
  </svg>
)

export default ArrowExpand